// extracted by mini-css-extract-plugin
export default {"cta":"nH-z","disabled":"oH-z"};